define('presentation/receptionist/dataSources/messageSubscriptionDataSource',['common/promises/promiseFactory',
        'common/promises/waitHandle',
        'constants/liveReceptionistScriptConstants',
        'constants/receptionistMessageConstants',
        'externalDependencies/clientWebSocket'
    ],
    function(PromiseFactoryConstructor, WaitHandleConstructor, liveReceptionistScriptConstants, receptionistMessageConstants, clientWebSocket) {

        let subscriptionWebSocket = clientWebSocket.forApplication('receptionistMessageSubscriptionDataSource');

        let promiseFactory = new PromiseFactoryConstructor();
        let waitForDataWaitHandle = new WaitHandleConstructor();
        waitForDataWaitHandle.setRedLight();

        subscriptionWebSocket.subscribeToEvent("receptionistMessageStatusChanged", (eventData) => {
            const { liveReceptionistScriptId, receptionistMessageId, newStatus } = eventData;

            onReceptionistMessageStatusChanged(liveReceptionistScriptId, receptionistMessageId, newStatus);
        });

        subscriptionWebSocket.subscribeToEvent('receptionistMessageAdded', (eventData) => {
            const { liveReceptionistScriptId, receptionistMessageId, status } = eventData;

            onReceptionistMessageAdded(liveReceptionistScriptId, receptionistMessageId, status);
        });

        subscriptionWebSocket.subscribeToEvent('receptionistMessageDeleted', (eventData) => {
            const { liveReceptionistScriptId, receptionistMessageId } = eventData;

            onReceptionistMessageDeleted(liveReceptionistScriptId, receptionistMessageId);
        });

        subscriptionWebSocket.subscribeToEvent("liveReceptionistScriptSubscriberSettingsChanged", (eventData) => {
            const { liveReceptionistScriptId, newReceptionistMessageIds, isActiveSubscriber, isPushToWebAppEnabled } = eventData;

            onSubscriberSettingsChanged(liveReceptionistScriptId, newReceptionistMessageIds, isActiveSubscriber, isPushToWebAppEnabled);
        });

        subscriptionWebSocket.subscribeToEvent("liveReceptionistScriptStatusChanged", (eventData) => {
            const { liveReceptionistScriptId } = eventData;

            onLiveReceptionistScriptStatusChanged(liveReceptionistScriptId);
        });

        const onReceptionistMessageStatusChanged = (liveReceptionistScriptId, receptionistMessageId, newStatus) => {
            let subs = subscriptions();
            let foundSubscription = subs.find((sub) => sub.liveReceptionistScriptId === liveReceptionistScriptId);
            if (foundSubscription) {
                let newMessageIds = foundSubscription.newReceptionistMessageIds();

                switch (newStatus) {
                    case receptionistMessageConstants.status.new.id:
                        if (newMessageIds.includes(receptionistMessageId) === false) {
                            foundSubscription.newReceptionistMessageIds.push(receptionistMessageId);
                        }
                        break;
                    case receptionistMessageConstants.status.reviewed.id:
                        if (newMessageIds.includes(receptionistMessageId)) {
                            foundSubscription.newReceptionistMessageIds.remove(receptionistMessageId);
                        }
                        break;
                }
            }
        };

        const onReceptionistMessageDeleted = (liveReceptionistScriptId, receptionistMessageId) => {
            _removeReceptionistMessage(liveReceptionistScriptId, receptionistMessageId);
        };

        const onReceptionistMessageAdded = (liveReceptionistScriptId, receptionistMessageId, status) => {
            if (status === receptionistMessageConstants.status.new.id) {
                _addReceptionistMessage(liveReceptionistScriptId, receptionistMessageId);
            }
        };

        const onSubscriberSettingsChanged = (liveReceptionistScriptId, newReceptionistMessageIds, isActiveSubscriber, isPushToWebAppEnabled) => {
            if (isActiveSubscriber === true && isPushToWebAppEnabled === true) {
                _addSubscription(liveReceptionistScriptId, newReceptionistMessageIds);
            } else {
                _removeSubscription(liveReceptionistScriptId);
            }
        };

        const onLiveReceptionistScriptStatusChanged = (liveReceptionistScriptId, newStatus) => {
            if (newStatus === liveReceptionistScriptConstants.status.deactivated.id)
            {
                _removeSubscription(liveReceptionistScriptId);
            }
        };

        const _addReceptionistMessage = (liveReceptionistScriptId, receptionistMessageId) => {
            let subs = subscriptions();
            let foundSubscription = subs.find((sub) => sub.liveReceptionistScriptId === liveReceptionistScriptId);
            if (foundSubscription) {
                let newMessageIds = foundSubscription.newReceptionistMessageIds();
                if (newMessageIds.includes(receptionistMessageId) === false) {
                    foundSubscription.newReceptionistMessageIds.push(receptionistMessageId);
                }
            }
        };

        const _removeReceptionistMessage = (liveReceptionistScriptId, receptionistMessageId) => {
            let subs = subscriptions();
            let foundSubscription = subs.find((sub) => sub.liveReceptionistScriptId === liveReceptionistScriptId);
            if (foundSubscription) {
                let newMessageIds = foundSubscription.newReceptionistMessageIds();
                if (newMessageIds.includes(receptionistMessageId) === true) {
                    foundSubscription.newReceptionistMessageIds.remove(receptionistMessageId);
                }
            }
        };

        const _removeSubscription = (liveReceptionistScriptId) => {
            subscriptions.remove((subscription) => {
                return subscription.liveReceptionistScriptId === liveReceptionistScriptId;
            });
        };

        const _addSubscription = (liveReceptionistScriptId, displayName, newMessageIds) => {
            const newReceptionistMessageIds = ko.observableArray(newMessageIds);
            const newReceptionistMessageCount = ko.pureComputed(() => {
                return newReceptionistMessageIds().length;
            });

            const newSubscription = {
                liveReceptionistScriptId: liveReceptionistScriptId,
                displayName: displayName,
                newReceptionistMessageIds: newReceptionistMessageIds,
                newReceptionistMessageCount: newReceptionistMessageCount
            };

            let subs = subscriptions();
            let foundSubscription = subs.find((sub) => sub.liveReceptionistScriptId === liveReceptionistScriptId);
            if (foundSubscription) {
                subscriptions.replace(foundSubscription, newSubscription);
            } else {
                subscriptions.push(newSubscription);
            }
        };

        const init = () => {
            return promiseFactory.defer((promise) => {
                subscriptionWebSocket.send('getInitialWebSubscriptions', {}, (data, errMsg) => {
                    if (errMsg) {
                        throw new Error(errMsg);
                    }

                    let subs = data.map((item) => {

                        const newReceptionistMessageIds = ko.observableArray(item.newMessageIds);
                        const newReceptionistMessageCount = ko.pureComputed(() => {
                            return newReceptionistMessageIds().length;
                        });

                        return {
                            liveReceptionistScriptId: item.liveReceptionistScriptId,
                            displayName: item.displayName,
                            newReceptionistMessageIds : newReceptionistMessageIds,
                            newReceptionistMessageCount : newReceptionistMessageCount,
                        };
                    });

                    subscriptions(subs);

                    waitForDataWaitHandle.setGreenLight();
                    promise.resolve();
                });
            });
        };

        const subscriptions = ko.observableArray([]);
        const totalNewMessages = ko.computed(() => {
            let total = 0;

            subscriptions().forEach((subscription) => {
                total = total + subscription.newReceptionistMessageCount();
            });
            return total;
        });

        const onLogin = () => {
            return init();
        };

        const onLogout = () => {
            waitForDataWaitHandle.setRedLight();
            subscriptions([]);
        };

        return {
            waitForDataWaitHandle,
            subscriptions,
            totalNewMessages,

            alerts : {
                receiveAlertLoginSuccessful : onLogin,
                receiveAlertLogout : onLogout,
            }
        };
    });
